import { memo, PropsWithChildren } from 'react';

import { IButtonProps } from 'shared/Houston';

import { Button } from './styles';

const ButtonOutline: React.FC<PropsWithChildren<IButtonProps>> = ({ children, ...rest }) => {
  return (
    <Button variant='outlined' {...rest}>
      {children}
    </Button>
  );
};

export default memo(ButtonOutline);
